exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fade-enter-active[data-v-0a9dd4ba], .fade-leave-active[data-v-0a9dd4ba] {\n    transition: opacity 0.2s;\n}\n.fade-enter[data-v-0a9dd4ba], .fade-leave-to[data-v-0a9dd4ba] {\n    opacity: 0;\n}\n", ""]);

// exports
